'use client';

import { cn } from '@/shared/utils/tw';
import { InfoIcon } from './icons/info-icon';
import type { Toast } from '../types/toast-types';

interface ToastInfoProps {
  toast: Toast;
}

/**
 * Toast-Info: 정보 토스트 (파란색 아이콘 포함)
 */
export const ToastInfo = ({ toast }: ToastInfoProps) => (
  <div
    className={cn(
      'bg-[rgba(255,255,255,0.2)]',
      'backdrop-blur-[20px]',
      '[-webkit-backdrop-filter:blur(20px)]',
      'rounded-full',
      'px-[18px] py-2',
      'flex items-center gap-1',
      'font-pretendard text-sm font-normal text-white',
      'pointer-events-auto',
      toast.isExiting ? 'animate-toast-exit' : 'animate-toast-enter'
    )}
  >
    <InfoIcon className="w-[18px] h-[18px] text-[#0175FF] flex-shrink-0" />
    <span>{toast.message}</span>
  </div>
);
